var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { staticClass: "mb-2", attrs: { row: "" } },
    [
      _c("v-icon", [_vm._v("wc")]),
      _vm._v(" "),
      _c(
        "v-btn-toggle",
        {
          staticClass: "ml-3",
          on: {
            change: function($event) {
              return _vm.updateGender()
            }
          },
          model: {
            value: _vm.genderModel,
            callback: function($$v) {
              _vm.genderModel = $$v
            },
            expression: "genderModel"
          }
        },
        [
          _c("v-btn", { attrs: { flat: "", value: _vm.clientModel.mister } }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("mister")))])
          ]),
          _vm._v(" "),
          _c("v-btn", { attrs: { flat: "", value: _vm.clientModel.miss } }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("miss")))])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15ce1411", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15ce1411","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzSelectGender.vue
// module id = null
// module chunks = 